export * from "../../original/js/components/maps";

// soon to be depricated.
import { Maps } from "../../original/js/components/maps";

export default Maps;
